// extracted by mini-css-extract-plugin
export default {"Disabled":"AgeGateForm_Disabled__N9Qhb"};